import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../shared/components';
import { api } from '../../utils/api';
import './CollegeAlgebra.css';

export default function Units() {
  const [units, setUnits] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/college-algebra/units')
      .then(setUnits)
      .catch(() => setError('Unable to load course units right now.'));
  }, []);

  return (
    <div className="ca-page">
      <h1>College Algebra</h1>
      <p className="ca-page-intro">
        Follows the UT OnRamps College Algebra (M 301 / MATH 1314) unit outline. Each unit has a lesson for every
        concept, an adaptive practice quiz across the whole unit, and a unit test.
      </p>
      {error && <p className="ca-error">{error}</p>}

      <div className="ca-unit-list">
        {units.map((unit) => (
          <Link key={unit.id} to={`/college-algebra/units/${unit.slug}`} className="ca-unit-link-card">
            <Card className="ca-unit-card">
              <h2>{unit.name}</h2>
              <p>{unit.description}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
